<template>
    <div class="stats">
        <div class="stat">
            <div class="label">{{__('games.avg3')}}</div>
            <div class="value">{{avg3dart}}</div>
        </div>
        <div class="stat">
            <div class="label">{{__('games.avg1')}}</div>
            <div class="value">{{avg1dart}}</div>
        </div>
        <div class="stat">
            <div class="label">{{__('games.darts')}}</div>
            <div class="value">{{dartcount}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['content', 'player_id'],
        data() {
            return {
                avg3dart: 0,
                avg1dart: 0,
                dartcount: 0,
            }
        },
        watch: {
            content: function(newVal, oldVal) {
                this.updateStats(newVal)
            }
        },
        mounted() {
            this.updateStats();
        },
        methods: {
            updateStats(newcontent) {
                if (!this.content || !this.content.throws) {
                    this.avg3dart = 0;
                    this.avg1dart = 0;
                    this.dartcount = 0;
                    return;
                };
                this.dartcount = 0;
                var score = this.content.start;
                this.content.throws.forEach(t => {
                    if (t.player == this.player_id) {
                        score -= parseInt(t.fullscore);
                        this.dartcount += 3;
                    }
                });
                this.avg3dart = ((this.content.start - score) / this.dartcount * 3).toFixed(2);
                this.avg1dart = ((this.content.start - score) / this.dartcount).toFixed(2);

                if (isNaN(this.avg3dart)) this.avg3dart = 0;
                if (isNaN(this.avg1dart)) this.avg1dart = 0;
            }
        }
    }
</script>

<style scoped>
</style>
